import { ImportPlanRequest } from './../domain/requests/plans/import-plan-request';
import { Observable } from 'rxjs';
import { BaseGridResponse } from '../../data/shared/base-grid.response';
import {
  AttachScheduler,
  AttachSchedulerRequest,
  BindLocationWithMultiplePlansJobRequest,
  CalculatePlanETARequest,
  ClonePlanRequest,
  GenerateRoutesRequest,
  GetPlansRequest,
  InjectPlanLocationRequest,
  OptimizePlanRequest,
  Plan,
  PlanRequest,
  PlanRevisionRequest,
  PlanWithJobRequest,
  PlanWithLocationRequest,
  UnCommitPlanRequest,
} from '../domain';
import { BaseRequest } from '../../data/shared/base.request';
import { PlanDetailsRequest } from '../domain/requests/plans/plan-details-request';
import { HttpResponse } from '@angular/common/http';
import { PlanJobDetails } from '../domain/models/plan-job-details';
import { DeleteCompletePlanReques } from '../domain/requests/plans/delete-complete-plan';
import { ValidateJLCsvFileResponse } from '../domain/requests/plans/ValidateJLCsvFileResponse';
import { AssignLocationsGroupsToPlanRequest } from '../domain/requests/plans/assign-location-to-plan-request';
import { createCompleteHDPlanRequest } from '../domain/requests/plans/remote-plan-request';
import { BaseResponse } from '../../data/shared/base.response';

export abstract class PlansRepository {
  abstract getPlans(
    request: BaseRequest<GetPlansRequest>
  ): Observable<BaseGridResponse<Plan>>;

  abstract addPlan(request: PlanRequest): Observable<string>;

  abstract addPlanWithJob(request: PlanWithJobRequest): Observable<boolean>;

  abstract unCommitPlan(request: UnCommitPlanRequest): Observable<boolean>;

  abstract removePlanScheduler(request: string): Observable<boolean>;

  abstract editPlanWithJob(request: PlanWithJobRequest): Observable<boolean>;

  abstract generateRoutes(request: GenerateRoutesRequest): Observable<boolean>;

  abstract attachScheduler(
    request: AttachSchedulerRequest
  ): Observable<boolean>;

  abstract getScheduler(request: string): Observable<AttachScheduler>;

  abstract planRevision(request: PlanRevisionRequest): Observable<boolean>;

  abstract addPlanWithLocation(
    request: PlanWithLocationRequest
  ): Observable<string>;

  abstract editPlan(request: PlanRequest): Observable<string>;

  abstract assignLocationsGroupsToPlan(request: AssignLocationsGroupsToPlanRequest): Observable<boolean>;
  
  abstract deletePlan(request: DeleteCompletePlanReques): Observable<boolean>;

  abstract clonePlan(request: ClonePlanRequest): Observable<Plan>;

  abstract optimizePlan(request: OptimizePlanRequest): Observable<boolean>;

  abstract calculatePlanETA(
    request: CalculatePlanETARequest
  ): Observable<boolean>;

  abstract calculateHDPlanETA(
    request: CalculatePlanETARequest
  ): Observable<boolean>;
  
  abstract importPlan(request?: ImportPlanRequest): Observable<boolean>;

  abstract importPlanCSV(request: FormData): Observable<boolean>;
  abstract exportPlanCSV(
    request: BaseRequest<string>
  ): Observable<HttpResponse<Blob>>;

    
  abstract importJobsCSV(request: ValidateJLCsvFileResponse): Observable<boolean>;
  
  abstract validateJobsCSV(request: FormData): Observable<ValidateJLCsvFileResponse>;

  abstract exportPlanToCSV(
    request: BaseRequest<string>
  ): Observable<HttpResponse<Blob>>;

  // abstract getAllPlanJobs(
  //   request: BaseRequest<PlanDetailsRequest>
  // ): Observable<PlanDetails[]>;
  abstract getPlanJobDetails(
    request: BaseRequest<PlanDetailsRequest>
  ): Observable<PlanJobDetails>;
  abstract bindLocationWithMultiplePlanJob(
    request: BindLocationWithMultiplePlansJobRequest
  ): Observable<boolean>;

  abstract getPlanById(request: string): Observable<Plan>;

  abstract injectPlanLocations(request: InjectPlanLocationRequest): Observable<string>;
  abstract importPlanLocationCSV(request: FormData): Observable<boolean>;

   abstract addPlanFromAms(request: createCompleteHDPlanRequest): Observable<BaseResponse<boolean>>;
}
